<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action corner" :class="{'hide-parent-popup': isChildPopupShown}">
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">アップデート通知の設定</span>
        </div>
        <div class="popup-content">
          <ul class="popup-content-list">
            <li class="popup-content-list-item popup-content-list-item-01">
              <p class="hdg04 mb16">配信方法</p>
              <p class="txt-sup mb16">アップデート通知の配信方法を設定できます。</p>
              <div class="formparts select"
                v-click-outside="() => { group1.isVisibleAlertSelect = false }"
                :class="{'is-visible-list': group1.isVisibleAlertSelect}"
                >
                <div @click="group1.isVisibleAlertSelect = !group1.isVisibleAlertSelect"
                class="select-label" role="select">{{ group1.alert_flgDisp }}<FontawesomeIcon :icon="group1.isVisibleAlertSelect ? 'angle-up' : 'angle-down'" class="icn" /></div>
                <div class="select-option">
                  <ul class="select-option-list">
                    <li role="option" v-for="(item, index) in group1.alert_flg_list" :key="'alert_flg_' + index">
                      <label><input type="radio" v-model.number="group1.alert_flg" :value="item.value" 
                      @change="group1.onAlertFlgChanged" @click="group1.isVisibleAlertSelect = false">{{ item.name }}</label>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="popup-content-list-item popup-content-list-item-02"
              v-if="group1.alert_flg !== 9"
            >
              <p class="hdg04 mb16">配信書籍</p>
              <p class="txt-sup mb16">更新情報を希望する書籍を選択できます。選択されていない場合は配信されません。</p>
              <div class="button">
                <button class="btn" type="button" name="button"
                @click="group1.onBookSettingButtonClicked"
                >書籍の設定</button>
              </div>
            </li>
            <li class="popup-content-list-item popup-content-list-item-03"
              v-if="group1.alert_flg !== 9 && group1.isKnowledgeContentsShown"
            >
              <p class="hdg04 mb16">気になるキーワード</p>
              <p class="txt-sup mb16">気になるキーワードを入力して追加ボタンを押してください。キーワードは2文字以上で最大10件まで設定可能です。</p>

              <form @submit.prevent="group1.onAddAlertTagButtonClicked()">
                <div v-if="group1.alert_tags.length < 10" class="formparts function mb16">
                  <input type="text" v-model="group1.alert_tag" placeholder="キーワードを入力">
                  <div @click="group1.onAddAlertTagButtonClicked()" class="button" role="button"><FontawesomeIcon icon="plus" class="icn" /></div>
                </div>
                <div v-else class="formparts text mb16">
                  <input type="text" v-model="group1.alert_tag" placeholder="キーワードを入力">
                </div>
                <p v-if="group1.error_alert_tags !== ''" class="error-message">{{ group1.error_alert_tags }}</p>
              </form>

              <div v-for="(tag, index) in group1.alert_tags" :key="'alert_tags_' + index" class="tag-list">
                <div class="tag">
                  <div role="button" class="tag-wrap">
                    <span class="tag-text">{{ tag }}</span>
                    <span @click="group1.onDeleteAlertTagButtonClicked(tag)" class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
                  </div>
                </div>
              </div>

            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'

export default defineComponent({
  props: {
    parentGroup1: {
      type: Object,
      required: true
    }
  },
  directives: {
    ClickOutside
  },
  setup (props, context) {

    const group1 = reactive({

      isVisibleAlertSelect: false,

      alert_flg: computed({
        get: () => {
          return context.parent.group1.alert_flg
        },
        set: (value) => {
          context.parent.group1.alert_flg = value
        }
      }),
    
      alert_flg_list: computed(() => {
        return context.parent.group1.alert_flg_list
      }),

      alert_flgDisp: computed(() => {
        let value = ''
        for (let i = 0; i < group1.alert_flg_list.length; i++) {
          if (group1.alert_flg === group1.alert_flg_list[i].value) {
            value = group1.alert_flg_list[i].name
            break
          }
        }
        return value
      }),

      alert_books: computed(() => {
        return context.parent.group1.alert_books
      }),

      alert_tags: computed(() => {
        return context.parent.group1.alert_tags
      }),
      
      error_alert_tags: computed(() => {
        return context.parent.group1.error_alert_tags
      }),

      isKnowledgeContentsShown: computed(() => {
        return context.parent.group1.isKnowledgeContentsShown
      }),

      /**
       * アラート書籍の設定（更新）
       */
      setAlertBooks: (alertBooks) => {
        context.emit('setAlertBooks', alertBooks)
      },

      onAlertFlgChanged: () => {
        context.parent.group1.onAlertFlgChanged()
      },

      /**
       * 書籍の設定ボタンを押下した場合
       */
      onBookSettingButtonClicked: () => {
        context.parent.state.visibleProfileContractedBookSetting = true

        // アラート一覧からの場合
        if (typeof context.parent._state !== 'undefined') {
          context.parent._state.visibleProfileContractedBookSetting = true
        }
      },

      /**
       * アラートタグの追加(+)ボタンを押下した場合
       */
      onAddAlertTagButtonClicked: () => {
        const inputAlertTag = group1.alert_tag
        context.parent.group1.onAddAlertTagButtonClicked(inputAlertTag)
      },

      /**
       * アラートタグの削除(×)ボタンを押下した場合
       */
      onDeleteAlertTagButtonClicked: (targetTag) => {
        context.parent.group1.onDeleteAlertTagButtonClicked(targetTag)
      }
    })


    const close = () => {
      context.emit('closeProfileAlertSetting')
    }
    const submit = () => {
      context.emit('closeProfileAlertSetting')
      // todo submitの処理
    }    

    /**
    * 子供のポップアップを表示しているか
    */
    const isChildPopupShown = computed(() => {
      return context.parent.state.visibleProfileContractedBookSetting
    })

    return {
      group1,
      close,
      submit,
      isChildPopupShown
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-action {
    width: 95px;
    height: 78px;
    border-top-left-radius: 8px;
    left: auto;
    right: 0;
  }
  &-action.wide {
    width: 100%;
    border-top-left-radius: 0;
    .button-close{
      position: absolute;
      right: 0;
    }
  }
}
.popup-content {
  padding: 0;
  &-list {
    list-style: none;
    &-item {
      padding: 20px;
      border-bottom: 1px solid $color-line;
      &-02 {
        .button {
          width: 180px;
          margin: 0 auto;
        }
      }
    }
  }
}

</style>
